import React, { Component } from 'react';
import { observer, inject } from 'mobx-react';
import { List, ListItem, ListItemIcon, ListItemText, Grid, Checkbox } from '@mui/material';
import CurrencyDisplay from '../common/CurrencyDisplay';

@inject('menuStore')
@observer
class SetMenu extends Component {
  handleClickSetMenu = (setMenuGroup, setMenu) => {
    this.props.menuStore.checkSetMenu(setMenuGroup, setMenu);
  };

  render() {
    const { menuStore } = this.props;

    return (
      <List className="option-group-list">
        {menuStore.selectedMenu.setMenuGroups.map((setMenuGroup, setMenuGroupIndex) => (
          <ListItem disableGutters dense key={setMenuGroupIndex} className="option-group">
            <Grid container direction="column">
              <Grid item className="option-group-title">
                <span>
                  {setMenuGroup.name} <span style={{ color: 'red' }}>*</span>
                </span>
              </Grid>
              <Grid item className="option-list">
                <List>
                  {setMenuGroup.setMenus.map((setMenu, setMenuIndex) => (
                    <ListItem
                      disableGutters
                      dense
                      button
                      key={setMenuIndex}
                      onClick={() => this.handleClickSetMenu(setMenuGroup, setMenu)}
                    >
                      <ListItemIcon>
                        <Checkbox edge="start" checked={setMenu.isChecked} tabIndex={-1} disableRipple />
                      </ListItemIcon>
                      <ListItemText
                        disableTypography
                        //primary={<span style={{ fontSize: '12pt' }}>{topping.name}</span>}
                        primary={
                          <Grid container>
                            <Grid item xs>
                              <span style={{ fontSize: '16px' }}>{setMenu.name}</span>
                            </Grid>
                            <Grid item>
                              <CurrencyDisplay amount={menuStore.getSetMenuPrice(setMenu)} fontWeight="normal" />
                            </Grid>
                          </Grid>
                        }
                        style={{ marginLeft: '-30px' }}
                      />
                    </ListItem>
                  ))}
                </List>
              </Grid>
            </Grid>
          </ListItem>
        ))}
      </List>
    );
  }
}

export default SetMenu;
